<template>
<div class="prize section" id="prize">
  <div class="layout-content">
    <SubTitle :text="title" :subText="subText" />
    <div class="main">
      <p v-if="data.desc" class="main-title">{{data.desc}}</p>

      <section v-if="isFeatureCompare" class="feature-compare" id="feature-compare">
        <div class="compare-intro">
          <span>FEATURE VISUAL STUDY</span>
          <h3>{{ featureVariantTitle }}</h3>
          <p>{{ featureVariantDescription }}</p>
        </div>

        <article v-if="featureVariant === 'a'" class="feature-variant feature-variant--number">
          <div class="variant-label">方案 A</div>
          <div class="variant-number"><span class="variant-icon variant-icon--history" aria-hidden="true"><svg viewBox="0 0 48 48"><path d="M10 19a15 15 0 1 1 3 17"/><path d="M10 10v9h9M24 14v11l7 5"/></svg></span><strong>08</strong><span>连续举办<br>八届赛事</span></div>
          <div class="variant-copy"><b>八届赛事积淀</b><p>{{ data.highlights.features[0].text }}</p></div>
          <div class="variant-rows"><div v-for="item in data.highlights.features.slice(1)" :key="`a-${item.index}`"><strong>{{ item.title }}</strong><span>{{ item.text }}</span></div></div>
        </article>

        <article v-if="featureVariant === 'b'" class="feature-variant feature-variant--strip">
          <div class="variant-label">方案 B</div>
          <h4>国际升级 · 权威指导 · 持续积淀</h4>
          <div class="variant-strip-list"><div v-for="item in data.highlights.features" :key="`b-${item.index}`"><i class="feature-line-icon" aria-hidden="true"><svg v-if="item.index === '01'" viewBox="0 0 48 48"><circle cx="24" cy="24" r="16"/><path d="M24 14v10l7 6"/></svg><svg v-else-if="item.index === '02'" viewBox="0 0 48 48"><path d="M8 34 19 23l8 7 13-16"/><path d="M31 14h9v9"/></svg><svg v-else viewBox="0 0 48 48"><circle cx="24" cy="24" r="16"/><path d="M16 24h16M24 16v16"/></svg></i><strong>{{ item.title }}</strong><p>{{ item.text }}</p></div></div>
        </article>

        <article v-if="featureVariant === 'c'" class="feature-variant feature-variant--focus">
          <div class="variant-label">方案 C</div>
          <div class="focus-main"><span class="focus-icon" aria-hidden="true"><svg viewBox="0 0 48 48"><path d="M24 39V9M14 19l10-10 10 10M12 39h24"/></svg></span><span>重点升级</span><h4>国际赛道<br>正式启航</h4><p>{{ data.highlights.features[2].text }}</p></div>
          <div class="focus-side"><div><b>08</b><span>八届赛事积淀</span></div><div><b>4</b><span>技术指导单位</span></div><div><b>3</b><span>大赛赛道</span></div></div>
        </article>
      </section>

      <section class="awards-section" id="awards" v-if="data.highlights && !isPrizeCompare">
        <div class="awards-layout">
          <aside class="prize-pool">
            <span>{{ data.highlights.prizeLabel }}</span>
            <div><strong>{{ data.highlights.prizeValue }}</strong><b>{{ data.highlights.prizeUnit }}</b></div>
          </aside>
          <div class="award-details">
            <div class="awards-grid">
              <article class="award-card" v-for="award in data.highlights.awards" :key="award.rank">
                <span class="award-icon" aria-hidden="true">
                  <svg viewBox="0 0 48 48"><path d="M15 7h18v11c0 6-4 10-9 10s-9-4-9-10V7Zm-5 3H6v4c0 7 4 11 10 12M38 10h4v4c0 7-4 11-10 12M24 28v7M17 40h14M18 35h12"/></svg>
                </span>
                <span class="award-rank">{{ award.rank }}</span>
                <strong class="award-amount">{{ award.amount }}</strong>
              </article>
            </div>
          </div>
        </div>
        </div>

        <p class="highlights-note">{{ data.highlights.note }}</p>
      </section>

      <section v-if="isPrizeCompare" class="prize-compare" id="prize-compare">
        <div class="compare-intro">
          <span>AWARD VISUAL STUDY</span>
          <h3>奖项设置 · 视觉方案对比</h3>
          <p>三种强调重点的呈现方式，分别突出仪式感、赛道结构和奖金数字。</p>
        </div>

        <article class="compare-card compare-card--podium">
          <div class="compare-card__head"><span>方案 A</span><strong>赛事颁奖台</strong><small>强调冠军与仪式感</small></div>
          <div class="podium-stage">
            <div class="podium-pool"><small>总奖金池</small><strong>75<span>万</span></strong></div>
            <div class="podium-bars"><div class="podium-bar podium-bar--silver"><b>二等奖</b><strong>8 万</strong></div><div class="podium-bar podium-bar--gold"><b>一等奖</b><strong>10 万</strong></div><div class="podium-bar podium-bar--bronze"><b>三等奖</b><strong>5 万</strong></div></div>
          </div>
          <div class="podium-creative">✦ 最佳创意奖 · 2 万元</div>
        </article>

        <article class="compare-card compare-card--matrix">
          <div class="compare-card__head"><span>方案 B</span><strong>三赛道矩阵</strong><small>强调赛道与评奖逻辑</small></div>
          <div class="matrix-grid"><div class="matrix-label">奖项</div><div>AI · 国内</div><div>数据分析</div><div>AI · 国际</div><template v-for="award in ['一等奖','二等奖','三等奖','最佳创意奖']"><div class="matrix-label" :key="`${award}-label`">{{ award }}</div><div :key="`${award}-ai`">{{ award === '一等奖' ? '10 万' : award === '二等奖' ? '8 万' : award === '三等奖' ? '5 万' : '2 万' }}</div><div :key="`${award}-data`">{{ award === '一等奖' ? '10 万' : award === '二等奖' ? '8 万' : award === '三等奖' ? '5 万' : '2 万' }}</div><div :key="`${award}-intl`">{{ award === '一等奖' ? '10 万' : award === '二等奖' ? '8 万' : award === '三等奖' ? '5 万' : '2 万' }}</div></template></div>
          <div class="matrix-total"><strong>75 万元</strong><span>三个赛道 · 各奖项 1 队 · 税前</span></div>
        </article>

        <article class="compare-card compare-card--number">
          <div class="compare-card__head"><span>方案 C</span><strong>金额大字报</strong><small>强调传播与第一眼记忆点</small></div>
          <div class="number-hero"><small>总奖金池 · 税前</small><strong>75<em>万</em></strong><i></i></div>
          <div class="number-list"><div><b>一等奖</b><strong>10 万元</strong></div><div><b>二等奖</b><strong>8 万元</strong></div><div><b>三等奖</b><strong>5 万元</strong></div><div><b>最佳创意奖</b><strong>2 万元</strong></div></div>
        </article>
      </section>
    </div>
  </div>
</div>
</template>

<script>
import SubTitle from '@/components/SubTitle'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
    SubTitle
  },
  computed: {
    ...mapState([
      'isMobile',
      'isEnLang'
    ]),
    title () {
      return this.isEnLang ? 'AWARDS & PRIZES' : '奖项设置'
    },
    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'FINTECHATHON'
    },
    isPrizeCompare () {
      return this.$route && this.$route.query && this.$route.query.prize === 'compare'
    },
    isFeatureCompare () {
      return false
    },
    featureVariant () {
      const value = this.$route && this.$route.query && this.$route.query.features
      return ['a', 'b', 'c'].includes(value) ? value : 'a'
    },
    featureVariantTitle () {
      return this.isEnLang ? `Competition Features · Version ${this.featureVariant.toUpperCase()}` : `大赛特色 · 方案 ${this.featureVariant.toUpperCase()}`
    },
    featureVariantDescription () {
      if (this.featureVariant === 'a') return this.isEnLang ? 'A large-number anchor makes the eight-edition legacy the first visual memory.' : '以“08”作为视觉锚点，先突出赛事积淀，再承接国际升级与权威指导。'
      if (this.featureVariant === 'b') return this.isEnLang ? 'A restrained horizontal information strip keeps the three highlights easy to scan.' : '用横向信息带承载三项重点，适合快速浏览，页面节奏更轻。'
      return this.isEnLang ? 'A focused composition makes the international upgrade the primary message.' : '以国际赛道升级为主视觉，适合突出本届赛事最重要的变化。'
    }
  }
}
</script>

<style lang="scss" scoped>
.prize {
  position: relative;
  padding: 120px 0 60px;
  background: $bgGrey;

  @include mobile {
    padding: 52px 0 25px;
  }
}

.layout-content {
  position: relative; z-index: 2;
}

.main-title {
  width: 920px;
  margin: 1px auto 42px;
  font-size: 17px; font-weight: 400;
  color: #535f73;
  text-align: center;
  line-height: 30px;

  @include mobile {
    width: 100%;
    margin-bottom: 24px;
    color: #000000;
    font-size: 13px; font-weight: 400;
    text-align: left;
    line-height: 26px;
  }
}

.highlights {
  position: relative;
  min-height: 0;
  padding: 34px 0 38px;
  border-top: 1px solid #cbd3df;
  border-bottom: 1px solid #cbd3df;
  background: transparent;
}

.awards-section {
  position: relative;
  margin-top: 42px;
  padding: 44px 48px 38px;
  color: #17233b;
  border-top: 0;
  background: #fff;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    right: -150px;
    bottom: -180px;
    width: 420px;
    height: 420px;
    border: 1px solid rgba(49,95,216,.08);
    border-radius: 50%;
    box-shadow: 0 0 0 42px rgba(237,49,95,.018), 0 0 0 84px rgba(116,75,218,.018);
    pointer-events: none;
  }
}

.highlights-orbit {
  display: none;
}

.section-heading {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  margin-bottom: 26px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dfe4ec;
}

.section-heading h3 {
  color: #17233b;
  font-family: Alibaba-PuHuiTi-Heavy;
  font-size: 25px;
  font-weight: 700;
  letter-spacing: .08em;
}

.section-heading p {
  margin-top: 5px;
  color: #7b8596;
  font-size: 13px;
  letter-spacing: .08em;
}

.feature-heading {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
  color: #315fd8;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: .12em;
}

.feature-heading i {
  width: 44px;
  height: 2px;
  border-radius: 99px;
  background: linear-gradient(90deg, #315fd8, #d83b68);
}

.feature-list {
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  border-top: 1px solid #d7dde6;
}

.feature-item {
  display: grid;
  grid-template-columns: 13px minmax(0, 1fr);
  gap: 15px;
  min-height: 168px;
  padding: 28px 24px;
  border-right: 1px solid #d7dde6;

  &:last-child { border-right: 0; }
}

.feature-item > span {
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 50%;
  background: #315fd8;
  box-shadow: 0 0 0 4px rgba(49,95,216,.1);
}

.feature-item strong {
  display: block;
  margin-bottom: 7px;
  color: #17233b;
  font-size: 18px;
  font-weight: 700;
}

.feature-item p {
  color: #687386;
  font-size: 15px;
  line-height: 1.75;
}

.prize-pool {
  position: relative;
  display: flex;
  min-height: 250px;
  padding: 12px 42px 12px 0;
  flex-direction: column;
  justify-content: flex-end;
  border-right: 1px solid #dfe4ec;
  color: #17233b;
  background: transparent;
  overflow: hidden;
}

.awards-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 26px;
}

.award-details {
  min-width: 0;
  margin-top: 26px;
}

.prize-pool::before {
  display: none;
}

.prize-pool > * {
  position: relative;
}

.prize-pool > span {
  margin-bottom: auto;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: .14em;
  opacity: .72;
  color: #315fd8;
}

.prize-pool div {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.prize-pool strong {
  font-family: DIN-BlackItalic, Alibaba-PuHuiTi-Heavy;
  font-size: 80px;
  line-height: 1;
}

.prize-pool b {
  font-size: 18px;
}

.prize-pool small {
  margin-top: 14px;
  font-size: 14px;
  color: #727d90;
  opacity: 1;
}

.award-heading {
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dfe4ec;
}

.award-heading span {
  color: #17233b;
  font-size: 18px;
  font-weight: 700;
}

.award-heading small {
  color: #8a93a3;
  font-size: 13px;
}

.highlights-note {
  position: relative;
  margin: 22px 0 0;
  padding: 13px 16px;
  border-left: 0;
  color: #596477;
  text-align: left;
  font-size: 14px;
  line-height: 23px;
  background: #f5f7fb;
}

.awards-grid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  border-top: 1px solid #d8dee8;
  border-left: 1px solid #d8dee8;
}

.award-card {
  position: relative;
  z-index: 0;
  display: flex;
  min-width: 0;
  min-height: 112px;
  padding: 24px 22px;
  flex-direction: column;
  justify-content: center;
  gap: 13px;
  border-right: 1px solid #d8dee8;
  border-bottom: 1px solid #d8dee8;
  background: #fff;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.award-card::before {
  display: none;
}

.award-card:hover {
  transform: none;
  background: #f3f6fd;
}

.award-rank,
.award-amount {
  position: relative;
  z-index: 1;
  color: #17233b;
}

.award-rank {
  font-size: 20px;
  font-weight: 600;
  color: #35415a;
}

.award-amount {
  font-family: DIN-BlackItalic, Alibaba-PuHuiTi-Heavy;
  font-size: 27px;
  line-height: 1;
  white-space: nowrap;
}

/* Award layout rollback: pool emphasis + four-column prize standard */
.awards-section { border-top: 0; }
.prize-pool {
  min-height: 146px;
  padding: 18px 34px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 18px;
  border: 0;
  border-right: 0;
  border-bottom: 1px solid #d8dee8;
  border-radius: 0;
  background: #fffaf5;
}
.prize-pool > span { margin: 0; color: #b52b3e; font-size: 17px; letter-spacing: .12em; opacity: 1; }
.prize-pool strong, .prize-pool b { color: #d02e3f; }
.prize-pool strong { font-size: 96px; text-shadow: 2px 3px 0 rgba(220,164,41,.2); }
.prize-pool b { font-size: 20px; color: #b57b1b; }
.prize-pool small { margin-top: 20px; font-size: 16px; }
.award-details { margin-top: 0; }
.award-heading span { font-size: 26px; }
.awards-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); border-top: 1px solid #d8dee8; border-left: 0; }
.award-card { min-height: 170px; padding: 24px 16px; align-items: center; gap: 16px; border-right: 1px solid #d8dee8; border-bottom: 1px solid #d8dee8; border-radius: 0; }
.award-card:first-child { border-left: 0; }
.award-card:last-child { border-right: 0; }
.award-icon { display: grid; place-items: center; width: 46px; height: 46px; border-radius: 50%; }
.award-icon svg { width: 28px; height: 28px; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.award-card:nth-child(1) .award-icon { color: #bd8619; background: #fff3cc; }
.award-card:nth-child(2) .award-icon { color: #7f91aa; background: #eef1f5; }
.award-card:nth-child(3) .award-icon { color: #b56c49; background: #f8e9df; }
.award-card:nth-child(4) .award-icon { color: #9a55a8; background: #f3e5f7; }
.award-rank { font-size: 20px; }
.award-amount { font-size: 30px; }

.award-details { width: 100%; }
.awards-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.award-card--0 .award-amount { color: #bf820e !important; }
.award-card--1 .award-amount { color: #73839b !important; }
.award-card--2 .award-amount { color: #ad6544 !important; }
.award-card--3 .award-amount { color: #944ba4 !important; }

.award-card:nth-child(1) .award-amount { color: #c58a20 !important; }
.award-card:nth-child(2) .award-amount { color: #78889e !important; }
.award-card:nth-child(3) .award-amount { color: #b56c49 !important; }
.award-card:nth-child(4) .award-amount { color: #944ba4 !important; }

.feature-compare { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; margin-top: 30px; }
.feature-compare .compare-intro { grid-column: 1 / -1; }
.feature-variant { position: relative; min-height: 390px; padding: 27px; border: 1px solid #dfe4ec; border-radius: 18px; overflow: hidden; }
.variant-label { color: #315fd8; font-family: DIN-BlackItalic, DIN; font-size: 12px; letter-spacing: .12em; }
.variant-number { display: flex; align-items: flex-end; gap: 14px; margin: 28px 0 14px; }
.variant-icon { display: grid; place-items: center; width: 44px; height: 44px; margin-bottom: 4px; border: 1px solid rgba(49,95,216,.2); border-radius: 50%; color: #315fd8; background: rgba(49,95,216,.07); }
.variant-icon svg, .feature-line-icon svg, .focus-icon svg { width: 24px; height: 24px; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.variant-number strong { color: #315fd8; font-family: DIN-BlackItalic, DIN; font-size: 92px; line-height: .8; }
.variant-number span { color: #17233b; font-size: 15px; font-weight: 700; line-height: 1.4; }
.variant-copy { padding-bottom: 20px; border-bottom: 1px solid rgba(49,95,216,.16); }
.variant-copy b { color: #17233b; font-size: 19px; }
.variant-copy p, .variant-rows span, .variant-strip-list p, .focus-main p { display: block; margin-top: 8px; color: #69758a; font-size: 12px; line-height: 1.7; }
.variant-rows > div { display: grid; grid-template-columns: 100px 1fr; gap: 10px; padding: 12px 0; border-bottom: 1px solid #edf0f5; }
.variant-rows strong { color: #315fd8; font-size: 12px; }
.feature-variant--number { background: linear-gradient(145deg, #f4f7ff 0%, #fff 72%); border-top: 4px solid #315fd8; }
.feature-variant--strip { background: #fff; border-top: 4px solid #e13e72; }
.feature-variant--strip h4 { margin: 28px 0 22px; color: #17233b; font-size: 22px; line-height: 1.35; }
.variant-strip-list > div { display: grid; grid-template-columns: 28px 1fr; column-gap: 10px; padding: 12px 0; border-bottom: 1px solid #edf0f5; }
.variant-strip-list i { grid-row: 1 / 3; color: #e13e72; font-style: normal; }
.feature-line-icon { display: grid; place-items: center; width: 24px; height: 24px; }
.feature-line-icon svg { width: 20px; height: 20px; }
.variant-strip-list strong { color: #17233b; font-size: 13px; }
.variant-strip-list p { grid-column: 2; margin-top: 4px; font-size: 11px; }
.feature-variant--focus { display: grid; grid-template-columns: 1fr 116px; align-content: center; gap: 20px; color: #fff; border: 0; background: linear-gradient(145deg, #1d315e, #315fd8); }
.feature-variant--focus .variant-label { position: absolute; top: 27px; left: 27px; color: #a9c2ff; }
.focus-main { padding-top: 30px; }
.focus-icon { display: grid; place-items: center; width: 42px; height: 42px; margin-bottom: 18px; border: 1px solid rgba(255,255,255,.35); border-radius: 50%; color: #ffb0c5; }
.focus-main > span { color: #ffb0c5; font-size: 12px; }
.focus-main h4 { margin-top: 14px; color: #fff; font-size: 27px; line-height: 1.3; }
.focus-main p { color: rgba(255,255,255,.7); }
.focus-side { align-self: center; }
.focus-side > div { padding: 13px 0; border-bottom: 1px solid rgba(255,255,255,.2); }
.focus-side b { display: block; color: #ffb0c5; font-family: DIN-BlackItalic, DIN; font-size: 30px; line-height: 1; }
.focus-side span { display: block; margin-top: 5px; color: rgba(255,255,255,.72); font-size: 10px; line-height: 1.35; }

.prize-compare { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; margin-top: 42px; }
.compare-intro { grid-column: 1 / -1; padding: 8px 0 10px; border-bottom: 1px solid #dfe4ec; }
.compare-intro > span { color: #d83b48; font-family: DIN-BlackItalic, DIN; font-size: 11px; letter-spacing: .16em; }
.compare-intro h3 { margin-top: 8px; color: #17233b; font-family: Alibaba-PuHuiTi-Heavy; font-size: 25px; }
.compare-intro p { margin-top: 5px; color: #7b8596; font-size: 13px; }
.compare-card { position: relative; min-height: 430px; padding: 24px; border: 1px solid #e0e5ed; border-radius: 18px; background: #fff; overflow: hidden; }
.compare-card__head { display: grid; grid-template-columns: auto 1fr; align-items: baseline; column-gap: 10px; padding-bottom: 15px; border-bottom: 1px solid rgba(35,53,92,.1); }
.compare-card__head span { color: #d83b48; font-family: DIN-BlackItalic, DIN; font-size: 13px; }
.compare-card__head strong { color: #17233b; font-size: 18px; }
.compare-card__head small { grid-column: 2; margin-top: 3px; color: #8a93a3; font-size: 11px; }
.compare-card--podium { border-top: 4px solid #d83b48; background: linear-gradient(160deg, #fff7f4, #fff); }
.podium-stage { display: flex; min-height: 280px; flex-direction: column; justify-content: flex-end; gap: 20px; }
.podium-pool small { display: block; color: #c83343; font-size: 12px; letter-spacing: .12em; }
.podium-pool strong { display: block; color: #d52f3d; font-family: DIN-BlackItalic, Alibaba-PuHuiTi-Heavy; font-size: 72px; line-height: .95; }
.podium-pool strong span { margin-left: 6px; font-size: 17px; }
.podium-bars { display: flex; align-items: flex-end; justify-content: center; gap: 7px; height: 145px; }
.podium-bar { display: flex; width: 30%; flex-direction: column; align-items: center; justify-content: flex-start; padding-top: 12px; color: #fff; border-radius: 8px 8px 0 0; font-size: 11px; }
.podium-bar strong { margin-top: 9px; font-family: DIN-BlackItalic, Alibaba-PuHuiTi-Heavy; font-size: 19px; }
.podium-bar--gold { height: 145px; background: #c99522; }
.podium-bar--silver { height: 108px; background: #8b99aa; }
.podium-bar--bronze { height: 84px; background: #b87855; }
.podium-creative { margin-top: 16px; color: #9452a5; font-size: 12px; font-weight: 700; text-align: center; }
.compare-card--matrix { border-top: 4px solid #315fd8; }
.matrix-grid { display: grid; grid-template-columns: 1.25fr repeat(3, 1fr); margin-top: 28px; border-top: 1px solid #dfe4ec; border-left: 1px solid #dfe4ec; font-size: 11px; text-align: center; }
.matrix-grid > div { min-height: 42px; display: grid; place-items: center; padding: 5px; border-right: 1px solid #dfe4ec; border-bottom: 1px solid #dfe4ec; color: #43516a; }
.matrix-grid > div:nth-child(4n+1) { color: #17233b; font-weight: 700; background: #f5f7fb; }
.matrix-grid > div:nth-child(-n+4) { color: #315fd8; font-weight: 700; background: #edf2ff; }
.matrix-total { display: flex; align-items: baseline; justify-content: space-between; margin-top: 28px; padding-top: 15px; border-top: 1px solid #dfe4ec; }
.matrix-total strong { color: #315fd8; font-family: DIN-BlackItalic, Alibaba-PuHuiTi-Heavy; font-size: 28px; }
.matrix-total span { color: #7b8596; font-size: 10px; }
.compare-card--number { border-top: 4px solid #d83b68; background: #17233b; }
.compare-card--number .compare-card__head strong { color: #fff; }
.compare-card--number .compare-card__head span { color: #ffb2c2; }
.compare-card--number .compare-card__head small { color: #aebbd0; }
.number-hero { position: relative; padding: 30px 0 23px; border-bottom: 1px solid rgba(255,255,255,.16); }
.number-hero small { color: #b8c4d8; font-size: 12px; }
.number-hero strong { display: block; color: #ff536a; font-family: DIN-BlackItalic, Alibaba-PuHuiTi-Heavy; font-size: 88px; line-height: .95; }
.number-hero em { margin-left: 8px; color: #ffd36a; font-size: 20px; font-style: normal; }
.number-hero i { position: absolute; right: 12px; top: 39px; width: 80px; height: 80px; border: 1px solid rgba(255,211,106,.42); border-radius: 50%; box-shadow: 0 0 0 14px rgba(255,211,106,.06), 0 0 0 28px rgba(255,83,106,.05); }
.number-list { margin-top: 22px; }
.number-list div { display: flex; align-items: center; justify-content: space-between; padding: 13px 0; border-bottom: 1px solid rgba(255,255,255,.12); }
.number-list b { color: #dce4f1; font-size: 13px; }
.number-list strong { color: #ffd36a; font-family: DIN-BlackItalic, Alibaba-PuHuiTi-Heavy; font-size: 20px; }

@include mobile {
  .highlights {
    min-height: 0;
    padding: 28px 0 24px;
  }

  .awards-section {
    margin-top: 16px;
    padding: 30px 22px 26px;
  }

  .section-heading {
    margin-bottom: 20px;
  }

  .section-heading h3 {
    font-size: 21px;
  }

  .highlights-orbit {
    top: -290px;
    left: -300px;
    width: 560px;
    height: 560px;
    border-width: 14px;
  }

  .feature-list {
    grid-template-columns: 1fr;
  }

  .feature-item {
    grid-template-columns: 13px minmax(0, 1fr);
    min-height: 0;
    padding: 20px 4px;
    border-right: 0;
    border-bottom: 1px solid #d7dde6;

    &:last-child { border-bottom: 0; }
  }

  .prize-pool {
    min-height: 180px;
    padding: 0 0 26px;
    border-right: 0;
    border-bottom: 1px solid #dfe4ec;
  }

  .prize-pool strong {
    font-size: 60px;
  }

  .award-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .award-heading span {
    font-size: 18px;
  }

  .highlights-note {
    margin-top: 18px;
    font-size: 13px;
    line-height: 21px;
  }

  .awards-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0;
  }

  .award-card {
    min-height: 112px;
    padding: 20px 16px;
    gap: 13px;

    &:hover {
      transform: none;
    }
  }

  .award-rank {
    font-size: 18px;
  }

  .award-amount {
    font-size: 24px;
  }

  .feature-compare { grid-template-columns: 1fr; gap: 14px; margin-top: 24px; }
  .feature-compare .compare-intro { grid-column: auto; }
  .feature-variant { min-height: 0; padding: 22px 18px; }
  .variant-number strong { font-size: 72px; }
  .feature-variant--strip h4 { font-size: 20px; }
  .feature-variant--focus { grid-template-columns: 1fr 96px; gap: 12px; }
  .focus-main h4 { font-size: 23px; }

  .prize-compare { grid-template-columns: 1fr; gap: 14px; margin-top: 26px; }
  .compare-intro { grid-column: auto; }
  .compare-intro h3 { font-size: 21px; }
  .compare-card { min-height: 0; padding: 20px 18px; }
  .podium-stage { min-height: 250px; }
  .matrix-total { align-items: flex-start; flex-direction: column; gap: 4px; }
}
</style>
